import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import StudioProcess from './StudioProcess';


/** Growth (Cometa Labs) section of the one-page landing. Anchor: #growth */
const GrowthSection = () => {
  return (
    <div id="growth" className="apple-cometa of-anchor">
        {/* Section head */}
        <section className="of-hero of-rails">
          <div className="of-frame pt-24 md:pt-32 pb-12 md:pb-16">
            <span className="of-eyebrow">
              <span className="of-dot" /> Growth · In-house venture studio
            </span>
            <h2 className="of-display mt-6 text-5xl sm:text-6xl lg:text-7xl">
              Cometa <strong>Labs</strong>
            </h2>
            <p className="of-lede mt-6">
              Building and incubating early-stage crypto-native products and infrastructure, from ideation to scale.
            </p>
          </div>
        </section>

        {/* Body */}
        <section className="of-rails">
          <div className="of-frame py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-3">
              <span className="of-eyebrow">01 — About</span>
            </div>
            <div className="lg:col-span-9 space-y-6 text-[15px] md:text-base leading-[1.8] text-[color:var(--of-ink-dim)]">
              <div className="space-y-6">
                <h3 className="of-mono text-[11px] uppercase tracking-[0.08em] text-[color:var(--of-accent-2)]">Who We Are</h3>
                <p className="text-xl md:text-2xl leading-snug tracking-[-0.02em] text-white">
                  Cometa Labs is a venture studio run by founders, engineers and product experts who have taken a company from
                  first idea to acquisition.
                </p>
                <p>
                  We start companies and incubate them in-house. Product, engineering, brand, market testing and venture support
                  all sit inside the studio, so a new idea has what it needs from the first week.
                </p>
                <p>
                  Between us, we've built across Web3, AI, fintech, data analytics, gaming and digital ownership. That includes
                  founding Scarcity Labs and leading it through its acquisition by DraftKings.
                </p>
                <p>
                  Today, we bring that experience back to the earliest stage of company building: identifying opportunities,
                  rapidly turning ideas into working products, testing them in the real world, and building the teams and
                  foundations they need to become independent companies.
                </p>
              </div>
              <div className="space-y-6 pt-6">
                <h3 className="of-mono text-[11px] uppercase tracking-[0.08em] text-[color:var(--of-accent-2)]">Our Mission</h3>
                <p className="text-xl md:text-2xl leading-snug tracking-[-0.02em] text-white">
                  To turn ambitious ideas into lasting technology companies.
                </p>
                <p>
                  What usually separates a good idea from a real company is time, money and the right people. We close that gap
                  by putting capital, engineering, product thinking and execution to work on the idea at the same time.
                </p>
                <p>
                  We move quickly, test with real users and double down on what works. When a venture is ready, we spin it out
                  with its own team, funding and infrastructure to scale.
                </p>
                <p>Sometimes that means building alongside a founder. Sometimes it means starting before there is one.</p>
              </div>
              <div className="pt-2 flex flex-wrap items-center gap-3">
                <a href="https://www.cometalabs.com/" target="_blank" rel="noopener noreferrer" className="of-btn px-5 h-11 min-w-[11.5rem]">
                  Visit Cometa Labs <ArrowUpRight className="of-arrow w-4 h-4" />
                </a>
                <a href="https://x.com/Cometa_Labs" target="_blank" rel="noopener noreferrer" className="of-btn-ghost px-5 h-11 min-w-[11.5rem]" aria-label="Cometa Labs on X">
                  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                  @Cometa_Labs
                </a>
              </div>
            </div>
          </div>

        </section>

        {/* Studio process */}
        <section className="of-rails of-light of-studio-light">
          <div className="of-frame py-16 md:py-24">
            <div className="text-center mb-10 md:mb-14">
              <span className="of-eyebrow">02 — Incubation schedule</span>
              <h2 className="of-display mt-5 text-3xl md:text-5xl">
                From first idea to <strong>scaled product</strong>
              </h2>
            </div>
            <StudioProcess />
          </div>
        </section>
    </div>
  );
};

export default GrowthSection;
